const TIMER_SELECTOR = '[data-cart-reservation-timer]';
const DURATION_SECONDS = 5 * 60;

const timers = new WeakMap();

function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

function startTimer(element) {
  if (timers.has(element)) return;

  let remaining = DURATION_SECONDS;
  element.textContent = formatTime(remaining);

  const interval = window.setInterval(() => {
    remaining = Math.max(remaining - 1, 0);
    element.textContent = formatTime(remaining);

    if (remaining === 0) {
      window.clearInterval(interval);
      timers.delete(element);
    }
  }, 1000);

  timers.set(element, interval);
}

function initTimers() {
  document.querySelectorAll(TIMER_SELECTOR).forEach((element) => {
    if (element instanceof HTMLElement) startTimer(element);
  });
}

initTimers();

new MutationObserver(initTimers).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
